<template>

  <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bulma@0.9.4/css/bulma.min.css">
  <link rel="preconnect" href="https://fonts.googleapis.com">
  <link href="https://fonts.googleapis.com/css2?family=Nabla&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Rubik+Moonrocks&display=swap" rel="stylesheet">
  <link href="https://fonts.googleapis.com/css2?family=Open+Sans:ital,wght@0,300;0,400;0,500;0,600;0,700;0,800;1,300;1,400;1,500;1,600;1,700;1,800&family=Oswald:wght@200;300;400;500;600;700&display=swap" rel="stylesheet">


  <Nav/>
  <AboutMe/> 
  <TrackerComponent/>
  <SkillsComponent/>
  <ProjectsComponent/>
  <BasicFooter/>

</template>

<script>
import Nav from './components/nav.vue'
import AboutMe from './components/AboutMe.vue'
import TrackerComponent from './components/tracker.vue'
import SkillsComponent from './components/Skills.vue'
import ProjectsComponent from './components/Projects.vue'
import BasicFooter from './components/footer.vue'

export default {
  name: 'App',
  components: {
    Nav, BasicFooter, TrackerComponent, AboutMe, SkillsComponent, ProjectsComponent
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  /* color: #fff; */
  color: #777;
  background: #1b1c1e;
  margin: 0;
  padding: 0;
}

html {
  background: #1c014d;
  margin: 0;
  padding: 0;
}

.colors {
  background: #30008A;
  color: #7D4DFE;
}

#nav {
  z-index: 999 !important;
}

.navbar-item {
  background: #1b1c1e;
  margin: 0;
}

p {
  font-family: 'Open Sans', sans-serif;
  font-size: 101%;
}


.footer {
  padding: 3rem 1.5rem 2rem;
}

.Experience p {
  width: 60%;
}

video::-webkit-media-controls-volume-slider {
  display: none;
}

video::-webkit-media-controls-mute-button {
  display: none;
}

code {
  text-shadow: none !important;

  .token.operator {
    background: none !important;
  }

  .token.number {
    background: none !important;
    min-width: 0;
    text-align: center !important; 
    vertical-align: middle !important;
    margin-right: 0;
  }
}

</style>